import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { getApi } from '../../api/endpoints';
import Page from "../Page";
import FormPartial from "./FormPartial";
import PageContentWrapper from "../../components/PageContentWrapper";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import BatteryModel from '../../models/BatteryModel';

const New = (props) => {
  const [batteryModel, setBatteryModel] = useState(new BatteryModel());
  const [createApi] = getApi('createBatteryModel');
  const navigate = useNavigate();

  const createRecord = async (params) => {
    try {
      await createApi(params).unwrap();
      navigate("/battery_models");
    } catch (error) {
      setBatteryModel((prev_state) => {
        return {
          ...prev_state,
          errors: error.data.data.errors
        }
      })
    }
  }

  const onCreateClick = () => {
    try {
      createRecord((new BatteryModel(batteryModel)).toApiJson())
    } catch(error) {
      setBatteryModel(new BatteryModel(batteryModel))
    }
  }

  const onBackClick = () => {
    navigate("/battery_models")
  }
  
  return <Page
    uiPage={uiManager.getUiPage(PAGES.NewBatteryModelPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Battery Models", url: '/battery_models'}, { label: "Add Battery Model" }]}
    className={'add-BatteryModel-page'}
  >
    <PageContentWrapper contentHeading={"Add Battery Model"}>
      <div className='m-3'>
        <form className="row g-4" autoComplete="off">
          <FormPartial batteryModel={batteryModel} setBatteryModel={setBatteryModel} />
          <div className='mb-4 col-md-12'>
            <div>
              <button type="button" className="btn btn-voltup-theme" onClick={onBackClick} style={{ float: 'inline-start' }}>Back</button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={onCreateClick}>Create Battery Model</button>
            </div>
          </div>
        </form>
      </div>
    </PageContentWrapper>
  </Page>
};

export default New;
